import './utils/tooltips'
import './utils/toggles'
import './utils/smooth-scroll'
import './utils/search'
import './utils/animate'
import './menu/menu'
import './woocommerce/single-btn-add-to-cart'
import './woocommerce/mini-cart'
import './woocommerce/latest-products'
import './woocommerce/product-image-swiper'
import './woocommerce/upsell-swiper'
import './woocommerce/buy-notice'
import './woocommerce/update-coupon'
import './map/map'

// scss
import '../scss/style.scss'
